<script>
  export default {
    props: {
      overlayData: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<template>
  <div class="layout/margin:top:page">
    <p v-if="overlayData.status"
      class="
        $color/session
        $typography/size:medium
        typography
      "
      v-html="overlayData.status"
      >
    </p>
    <p v-if="overlayData.throughDate"
      class="
        $typography/size:medium
        typography
      "
      v-html="overlayData.throughDate"
      >
    </p>
  </div>
</template>